import { Helmet } from 'react-helmet-async';
import { PROJECT } from '~/constants';

export default function BasicHelmetHead() {
  return (
    <Helmet>
      <title>{PROJECT}</title>

      <meta
        property='og:title'
        content='Hey.D | Whatever you want with 3D &AI'
      />
    </Helmet>
  );
}
